import { ErrorHandler, Injectable, inject } from '@angular/core';
import {TranslateService} from '@app/shared/_services/translate.service';
import {getNewVersionAlert} from '@app/shared/_factories/newversion.alert';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private translateService = inject(TranslateService);

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error?.message)) {
      getNewVersionAlert(this.translateService)();
      return;
    }
    // Surface every other error instead of swallowing it silently.
    // A swallowed exception thrown during change detection leaves the UI
    // in an inconsistent state (e.g. a button stuck in its loading spinner)
    // with no visible crash, which is extremely hard to diagnose.
    console.error(error);
  }
}
